import { TSToChartEvent, } from '@thoughtspot/ts-chart-sdk';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
export const dispatchMixpanelEvent = async (commonProps, eventProps) => {
    const { iFrameWindow: iframeRef, appUrl } = commonProps;
    const { previousValue, columnId, changeInfo, context } = eventProps;
    const payload = {
        previousValue,
        columnId,
        changeInfo,
        context,
    };
    try {
        const res = await sendMessage(iframeRef, {
            eventType: TSToChartEvent.MixpanelEvent,
            payload,
        }, appUrl);
        if (!res.data) {
            return undefined;
        }
        return res.data;
    }
    catch (error) {
        return undefined;
    }
};
//# sourceMappingURL=index.js.map